module.exports = __webpack_public_path__ + "img/greenLight.4930b001.svg";